module.exports = __webpack_public_path__ + "static/img/phone1.e49285e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phone1.png
// module id = vh9e
// module chunks = 1